// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
/*globals data */
import '@/helpers/toastification';
// import cssVars from 'css-vars-ponyfill'
import Vue from 'vue';
import * as Sentry from '@sentry/vue';

import moment from 'moment-timezone';
import VueMoment from 'vue-moment';
Vue.use(VueMoment, {
  moment
});
window.$moment = moment;

const filter = function(text, length, clamp){
  clamp = clamp || '...';
  var node = document.createElement('span');
  node.innerHTML = text;
  var content = node.textContent;
  return content.length > length ? content.slice(0, length) + clamp : content;
};

Vue.filter('truncate', filter);

import * as TinyCookie from 'tiny-cookie'

import TextareaAutosize from 'vue-textarea-autosize'
Vue.use(TextareaAutosize)

//Vue.use(VueCookie);
import BootstrapVue from 'bootstrap-vue';
import App from './App';
import router from './router';
import store from './store';
Vue.prototype.jQuery = $;

import VueMeta from 'vue-meta'
Vue.use(VueMeta, {
  keyName: 'meta',
  attribute: 'data-vue-meta',
  ssrAttribute: 'data-vue-meta-server-rendered',
  tagIDKeyName: 'vmid',
  refreshOnceOnNavigation: true
})
import VeeValidate from 'vee-validate';
Vue.use(VeeValidate, {
  inject: true,
  fieldsBagName: 'veeFields',
  errorBagName: 'veeErrors'
});
import money from './views/components/vDecimalInput/index.js';
// register directive v-money and component <money>
Vue.use(money, {
  decimal: '.',
  thousands: ',',
  prefix: '',
  suffix: '',
  precision: 2,
  masked: true /* doesn't work with directive */
});
// Vue.use(Multiselect);
import 'vue-multiselect/dist/vue-multiselect.min.css';
import VueSweetalert2 from 'vue-sweetalert2';
Vue.use(VueSweetalert2);
import 'sweetalert2/dist/sweetalert2.min.css';
import Gravatar from 'vue-gravatar';
Vue.component('v-gravatar', Gravatar);
import vSelect from 'vue-select';
Vue.component('v-select', vSelect);
import 'vue-select/dist/vue-select.css';

// import InputTransition from './views/components/InputTransition.vue';
// Vue.component(InputTransition);
import VueTour from 'vue-tour'
require('vue-tour/dist/vue-tour.css')
Vue.use(VueTour)

import bsSelect from './views/components/BsSelect.vue';
import bsSelectMultiple from './views/components/BsSelectMultiple.vue';

Vue.component('b-v-select', bsSelect);
Vue.component('b-v-select-multi', bsSelectMultiple);

import flatPickr from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';
Vue.component('Flatpickr', flatPickr);

const $http = require('axios');
window.$http = Vue.prototype.$http = $http;

window.Sentry = Vue.prototype.Sentry = Sentry;
import VueBootstrapTypeahead from 'vue-bootstrap-typeahead';

import '@toast-ui/editor/dist/toastui-editor.css';
// Global registration
Vue.component('vue-bootstrap-typeahead', VueBootstrapTypeahead);
Vue.use(BootstrapVue);

Vue.config.productionTip = false

import NotificationsHub from './helpers/notificationsHub';
Vue.use(NotificationsHub);

import VueCountdown from '@chenfengyuan/vue-countdown';
Vue.component(VueCountdown.name, VueCountdown);

let dsnKey = 'https://7f5ba7cc37832ace914601e0ee711a5b@us.sentry.io/4506699681759232';
//let dsnKey = 'https://771919ac7dbf40fb96622a70a96b66fe@o4504445801988096.ingest.sentry.io/4504792779587584'
let envSentry = '';
if (window.location.hostname.includes('stagingadmin')) {
  envSentry = 'admin-staging';
} else if (window.location.hostname.includes('staging.')) {
  envSentry = 'brand-staging';
} else if (window.location.hostname.includes('admin.')) {
  envSentry = 'admin';
} else if (window.location.hostname.includes('localhost')) {
  envSentry = 'localhost';
} else {
  envSentry = 'brand';
}

$http.interceptors.response.use(
  (response) => response,
  (error) => {
    if(error && error.response && error.response.status == 401) {
      store.dispatch('account/refreshTokenOrLogout');
    }
    return Promise.reject(error);
  },
);
if(envSentry != 'localhost') {

  $http.interceptors.response.use(
    (response) => response,
    (error) => {
      if(error && error.response && error.response.status != 404 && !(error.response.config.url.includes('refresh-token'))) {
        if(error.response &&  error.response.data && (typeof error.response.data !== 'string' || (typeof error.response.data === 'string' && !error.response.data.includes('Site Under Construction')))) {
          Sentry.withScope(scope => {
            scope.setExtra('Method', error.response.config.method)
            scope.setExtra('Response', error.response.data)
            scope.setExtra('URL', error.response.config.url)
            error.name = 'API Error';
            error.message = 'API Call Failed for ' + error.response.config.url;
            if(error.request && error.request.__sentry_xhr__ && error.request.__sentry_xhr__.body) {
              if(typeof error.request.__sentry_xhr__.body === 'string') {
                try {
                   scope.setExtra('RequestSent', JSON.parse(error.request.__sentry_xhr__.body))
                } catch {
                  // do nothing
                }
              } else {
                if(error.request.__sentry_xhr__.body.includes('524: A timeout occurred')) {
                  scope.setExtra('RequestBody', 'CLOUDFLARE ERROR - 524: A timeout occurred');
                  error.name = error.name + " - TIMEOUT!"
                } else {
                  scope.setExtra('RequestBody', error.request.__sentry_xhr__.body)
                }
              }
            }
            // try {
            //    scope.setExtra('ResponseString', JSON.stringify(error.response.data))
            // } catch {}
            Sentry.captureException(error);
          });
        }
      }
      return Promise.reject(error);
    },
  );
  Sentry.init({
    environment: envSentry,
    Vue,
    dsn: dsnKey,
    normalizeDepth: 6,
    logErrors: true,
    trackComponents: true,
    integrations: [
      //new BrowserTracing(),
      new Sentry.Replay({
        maskAllInputs: false,
        maskAllText: false
      }),
    ],
    replaysOnErrorSampleRate: 1.0,
    replaysSessionSampleRate: 0,
    tracesSampleRate: 0.1
  });
}

if(process != undefined && process.env != undefined && process.env.VUE_APP_API_URL) {
  $http.defaults.baseURL = process.env.VUE_APP_API_URL;
  window.$http.defaults.baseURL = process.env.VUE_APP_API_URL;
}

window.$cookie = Vue.prototype.$cookie = TinyCookie;
/* eslint-disable no-new */
window.mainVue = new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app');

window.mainStore = store;

import './registerServiceWorker';
